<script lang="ts" setup>
import type { EventMergeRecord } from '@gmao/shared';
import type { ResetOverdueLog } from '@gmao/types';
import { computed } from 'vue';

const props = defineProps<{
  event: EventMergeRecord;
  events: EventMergeRecord[];
}>();

const log = computed(() => props.event.log as ResetOverdueLog);
</script>

<template>
  <div>
    <div font-bold>
      {{ log.taskName }}
    </div>
    <div
      v-if="log.comment"
      mt-2
    >
      Comment: {{ log.comment }}
    </div>
  </div>
</template>
